<div class="page-container">
  <app-custom-back-button *ngIf="tabIndexToReturn" [customUrl]="customUrl"></app-custom-back-button>
    <div class="top-toolbar">
        <div class="sub-title">SETTINGS</div>
    </div>
    <router-outlet></router-outlet>
</div>
